var map = {
	"./main_00001.svg": 3792,
	"./main_00002.svg": 3047,
	"./main_00003.svg": 3088,
	"./main_00004.svg": 1898,
	"./main_00005.svg": 5057,
	"./main_00006.svg": 3112,
	"./main_00007.svg": 4729,
	"./main_00008.svg": 8263,
	"./main_00009.svg": 9817,
	"./main_00010.svg": 8964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9136;